module.exports = __webpack_public_path__ + "img/支付宝.cf0d9ca6.png";